import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Homepage from "./pages/Homepage";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import CarPage from "./pages/CarPage";
import RequestPage from "./pages/RequestPage";
import Header from "./components/Header";
import Footer from "./components/Footer";

import CookieConsent from "react-cookie-consent";

import useUTMTracker from "./functions/hooks/useUTMTracker";

const App = () => {
  useUTMTracker(); // calling it here so it doesn't matter which page is the landing page

  return (
    <>
      <Header />
      <ScrollToTop />
      <ToastContainer />
      <Routes>
        {/* Homepage */}
        <Route path="/" element={<Homepage />} />

        {/* Car details page */}
        <Route path="/car/:id" element={<CarPage />} />

        {/* Car request page */}
        <Route path="/request/:id" element={<RequestPage />} />

        {/* 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />

      <CookieConsent
        location="bottom"
        buttonText="Prihvaćam"
        declineButtonText="Odbijam"
        cookieName="myCookieConsent"
        style={{
          background: "#1D1D1B",
          fontSize: "14px",
        }}
        buttonStyle={{
          color: "#1D1D1B",
          fontSize: "14px",
          background: "#fff",
          padding: "8px 20px",
          margin: "8px",
          borderRadius: "100px",
        }}
        contentClasses="cookie-content-class"
        declineButtonStyle={{
          color: "#fff",
          background: "red",
          fontSize: "14px",
        }}
        expires={150}
      >
        Ova web stranica koristi kolačiće kako bi poboljšali korisničko
        iskustvo. Pročitajte našu{" "}
        <a
          href="https://www.citroen.hr/korisne-informacije/izjava-o-privatnosti.html"
          target="#"
          className="border-b border-b-white"
        >
          Izjavu o Privatnosti
        </a>{" "}
        ovdje.
      </CookieConsent>
    </>
  );
};

export default App